<template>
  <el-dialog :visible.sync="dialogVisible" width="60%" :before-close="handleClose" class="recognition-valueLogic">
    <span slot="title" class="dialog-title">
      <span>{{ recognitionRule.title }}</span>
      <span class="sub-title">多字段组合+号隔开</span>
    </span>

    <div class="content-table">
      <el-table :data="tableData" :header-cell-style="styleObj" style="width: 100%">
        <el-table-column prop="index" label="序号" width="90" align="center"></el-table-column>
        <el-table-column prop="valueLogic" label="规则" align="center">
          <template #default="scope">
            <el-input v-model="scope.row.valueLogic" type="textarea" :rows="2" :maxlength="100" size="small"
              placeholder="请输入识别规则" v-if="scope.row.status === 'add' || scope.row.status === 'edit'" />
            <span v-else>{{ scope.row.valueLogic }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button @click="editClick(scope.row, scope.$index)" type="text" size="small"
              v-if="!scope.row.status">编辑</el-button>
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              v-if="scope.row.status === 'add' || scope.row.status === 'edit'">保存</el-button>
            <el-button type="text" size="small" @click="deleteRule(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addRuleItem" size="small">新增</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getQueryRuleById,
  saveRule,
  updateRule,
  deletedRule
} from "@/api/diseaseRule.js";
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      styleObj: {
        background: "#FAFAFA",
        fontWeight: "bold",
        color: "#333333",
        fontSize: "14px"
      }
    };
  },
  props: {
    recognitionRule: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    "recognitionRule.visible": {
      handler(val) {
        console.log("val", val);
        this.dialogVisible = val;
      }
    },
    "recognitionRule.id": {
      handler(val) {
        // 有id时调用接口获取关联的匹配规则
        this.getQueryRuleById();
      }
    }
  },
  mounted() {
    // 有id时调用接口获取关联的匹配规则，无id时不获取规则为空数组
    if (this.recognitionRule.id) {
      this.getQueryRuleById();
    } else {
      this.tableData = [];
    }
  },
  methods: {
    async getQueryRuleById() {
      let { code, data } = await getQueryRuleById(this.recognitionRule.id);
      if (code === 0) {
        console.log("data", data);
        this.tableData = data.map(item => {
          return {
            ...item,
            status: ""
          };
        });
      }
    },
    handleClose(done) {
      // 无id关闭弹框时保存一次至父组件
      if (!this.recognitionRule.id) {
        this.$emit("ruleChange", this.tableData);
      }
      done();
    },
    // 新增识别规则
    addRuleItem() {
      // 判断上一个识别规则是否填写完毕 并且判断是否已保存
      // 判断是否有未保存的数据，有则给出提示
      if (this.tableData && this.tableData.length === 0) {
        this.tableData.unshift({
          valueLogic: "",
          status: "add"
        });
      } else {
        let flag = false;
        this.tableData.forEach(item => {
          console.log("item", item);
          if (item.status) {
            flag = true;
          }
        });
        if (flag) {
          this.$message("请保存识别规则");
        } else {
          this.tableData.unshift({
            valueLogic: "",
            status: "add"
          });
        }
      }
    },
    // 编辑
    async editClick(item, index) {
      // this.tableData[index].status = "edit";
      // 点击编辑时判断是否有未保存的数据
      let flag = false;
      this.tableData.forEach(item => {
        if (item.status) {
          flag = true;
        }
      });
      if (flag) {
        this.$message("请保存识别规则");
      } else {
        item.status = "edit";
      }
    },
    // 保存规则 判断是否有id
    async handleClick(row) {
      if (row.valueLogic) {
        if (!this.recognitionRule.id) {
          // 无id 将数据存储保存给父元素---关闭弹框时保存给父组件
          // this.$emit('ruleChange', this.tableData);
          row.status = "";
        } else {
          // 有id 调用接口 判断有没有row.id 有的话调用编辑接口 无则调用保存接口
          if (row.id) {
            // 编辑接口
            let { code, data } = await updateRule({
              ...row
            });
            if (code === 0) {
              row.status = "";
              this.$message("识别规则编辑成功");
            }
          } else {
            let { code, data } = await saveRule({
              ...row
            });
            if (code === 0) {
              row.status = "";
              this.$message("识别规则保存成功");
            }
          }
        }
      } else {
        this.$message("请填写识别规则");
      }
    },
    // 删除规则
    async deleteRule(id) {
      if (id) {
        // 调用接口删除
        let { code, data } = await deletedRule(id);
        if (code === 0) {
          this.$message("识别规则删除成功");
        }
      } else {
        // 前端数组中删除
        this.tableData.splice(0, 1);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.el-dialog {
  .dialog-title {
    .sub-title {
      display: block;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      margin-top: 15px;
    }
  }
  .dialog-footer {
    display: block;
    text-align: center !important;
  }
}
</style>